import {
  FeatureFlagEnum,
  ModuleEnum,
  PermissionOperationEnum,
} from 'src/api/ProactApiClient';
import {ContentWrapper} from 'src/app/layout/ContentWrapper';
import {SiteDocumentTitle} from 'src/pages/Modules/Clients/shared/siteHelpers';
import {SiteForm} from 'src/pages/Modules/Clients/shared/SiteForm';
import {routeRegistry} from 'src/pages/RouteRegistry';
import {PathUtility} from 'src/shared/constants/PathBuilder';
import useSetDocumentTitle from 'src/shared/hooks/useSetDocumentTitle';

export const SiteCreatePage = () => {
  useSetDocumentTitle(SiteDocumentTitle);

  return (
    <ContentWrapper featureFlag={FeatureFlagEnum.Clients}>
      <SiteForm mode="create" />
    </ContentWrapper>
  );
};

// Register the route with the new system
routeRegistry.registerPageRoute({
  backNavigation: 'form',
  path: PathUtility.SitesCreate(),
  element: <SiteCreatePage />,
  module: ModuleEnum.Clients,
  operation: PermissionOperationEnum.Create,
  isPrivate: true,
});
